import { z } from 'zod';

export const additionalUploadsPostRequestSchema = z.object({});
